"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7427],{

/***/ 30887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36796);
/* harmony import */ var src_comps_Molecules_DatePicker__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39065);




var ConnectedDatePicker = function(param) {
    var mode = param.mode;
    var ref = (0,src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_2__/* .useSearch */ .R)(), draftCheckin = ref.draftCheckin, draftCheckout = ref.draftCheckout, minBookingDate = ref.minBookingDate, setDates = ref.setDates;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Molecules_DatePicker__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        initialValue: {
            checkIn: draftCheckin,
            checkOut: draftCheckout
        },
        onChange: setDates,
        firstAvailableDate: minBookingDate,
        mode: mode
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConnectedDatePicker);


/***/ }),

/***/ 77427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ comps_OmniSearch; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/comps/ConnectedDatePicker/index.tsx
var ConnectedDatePicker = __webpack_require__(30887);
// EXTERNAL MODULE: ./src/comps/SuggesterConnected/index.tsx
var SuggesterConnected = __webpack_require__(86998);
// EXTERNAL MODULE: ./src/comps/PaxesConnected/index.tsx
var PaxesConnected = __webpack_require__(17181);
// EXTERNAL MODULE: ./src/types/search.ts
var search = __webpack_require__(50728);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
// EXTERNAL MODULE: ./src/comps/Atom/Buttons/Button/styles.ts
var styles = __webpack_require__(27220);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var client_styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./src/comps/OmniSearch/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  pointer-events: ",
        ";\n  --search-items-height: 56px;\n  --inputs-border-radius: 100px;\n\n  width: 100%;\n  max-width: 1000px;\n\n  &.readonly,\n  &.borderless {\n    ",
        "\n    display: flex;\n    align-items: center;\n    border: 2px solid ",
        ";\n    border-radius: 50px;\n  }\n\n  &.readonly {\n    flex-wrap: wrap;\n    padding-block: 5px 6px;\n    padding-inline: 36px 10px;\n    margin-inline: 12px;\n    margin-block: 0;\n    max-width: calc(100% - 24px);\n    overflow: hidden;\n    svg {\n      position: absolute;\n      fill: ",
        ";\n      inset-inline-start: 10px;\n      inset-block-start: calc(50% - 10px);\n    }\n  }\n\n  &.borderless {\n    padding-block: 3px;\n    padding-inline: 3px;\n    border: 2px solid var(--color--neutral--400);\n    border-radius: var(--inputs-border-radius);\n    height: var(--search-items-height);\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: var(--color-neutral-100);\n\n    ",
        " {\n      line-height: 16px;\n      padding-block: 10px;\n      padding-inline: 12px;\n      border-radius: 50px;\n\n      ",
        " {\n        margin-inline: 8px 0;\n        margin-block: 8px;\n        width: 48px;\n        height: 48px;\n      }\n\n      ",
        " {\n        width: max-content;\n      }\n\n      & .buttonText {\n        ",
        " {\n          display: none;\n        }\n\n        ",
        " {\n          display: inline;\n        }\n      }\n    }\n  }\n\n  &.full {\n    flex-direction: column;\n    z-index: var(--z-low);\n    border: 2px solid var(--color--neutral--400);\n    border-radius: 35px;\n\n    > ",
        " {\n      padding-block: 10px;\n      padding-inline: 12px;\n      width: calc(100% - 24px);\n      border-radius: 50px;\n      margin-inline: auto;\n      margin-block: 8px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var OmniSearchContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__OmniSearchContent",
    componentId: "sc-71088358-0"
})(_templateObject());
var OmniSearchBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__OmniSearchBase",
    componentId: "sc-71088358-1"
})(_templateObject1(), function(props) {
    return props.disabled ? "none" : "auto";
}, function(props) {
    return props.isEbooking ? "background-color: ".concat(props.theme.colors.grey8, ";") : "";
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey5;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey3;
}, styles/* ButtonBase */.Xd, client_styles/* updatedMedia.onlyTablet */.$c.onlyTablet, client_styles/* updatedMedia.desktop */.$c.desktop, client_styles/* updatedMedia.onlyTablet */.$c.onlyTablet, client_styles/* updatedMedia.desktop */.$c.desktop, styles/* ButtonBase */.Xd);

// EXTERNAL MODULE: ./lib/storage.js
var storage = __webpack_require__(59588);
// EXTERNAL MODULE: ./client/utils.js + 2 modules
var utils = __webpack_require__(30796);
// EXTERNAL MODULE: ./client/icons/Search.tsx
var Search = __webpack_require__(22465);
// EXTERNAL MODULE: ./src/comps/SearchButton/index.tsx
var SearchButton = __webpack_require__(50138);
// EXTERNAL MODULE: ./src/hooks/useBusiness.ts
var useBusiness = __webpack_require__(16153);
// EXTERNAL MODULE: ./src/constants/affiliates.ts
var affiliates = __webpack_require__(1620);
// EXTERNAL MODULE: ../../node_modules/lodash/noop.js
var noop = __webpack_require__(34291);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/comps/OmniSearch/index.tsx















var OmniSearch = function(param) {
    var mode = param.mode, _preventNavigation = param.preventNavigation, preventNavigation = _preventNavigation === void 0 ? true : _preventNavigation, searchUrl = param.searchUrl, _onClick = param.onClick, onClick = _onClick === void 0 ? (noop_default()) : _onClick, disabled = param.disabled, stacked = param.stacked, _smallBtn = param.smallBtn, smallBtn = _smallBtn === void 0 ? false : _smallBtn;
    var href = searchUrl.href;
    var affiliate = (0,useBusiness/* useBusiness */.i)().affiliate;
    var isEbooking = affiliate === affiliates/* AFFILIATE_EBOOKING */.YK;
    var handleSearch = function(e) {
        e.stopPropagation();
        onClick(e);
        var paxes = (0,utils/* getPaxesfromUrlParams */.ch)({
            adults: href.query.adults,
            children: href.query.children
        });
        (0,storage/* setSearchParamsLocalStorage */.Im)({
            checkIn: href.query.checkin,
            checkOut: href.query.checkout,
            adults: paxes.adults,
            children: paxes.children
        });
    };
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggesterConnected/* default */.Z, {
                mode: mode,
                className: "suggester-wrapper"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedDatePicker/* default */.Z, {
                mode: mode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaxesConnected/* default */.Z, {
                mode: mode,
                disabled: disabled
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton/* default */.Z, {
                onClick: handleSearch,
                fullWidth: mode === search/* SearchMode.Full */.N3.Full,
                preventNavigation: preventNavigation,
                searchUrl: searchUrl,
                small: smallBtn && mode === search/* SearchMode.Borderless */.N3.Borderless
            })
        ]
    });
    if (mode === search/* SearchMode.Readonly */.N3.Readonly) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                    "data-testid": "search-icon",
                    size: 20
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggesterConnected/* default */.Z, {
                    mode: mode,
                    className: "suggester-wrapper"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(OmniSearchContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedDatePicker/* default */.Z, {
                            mode: mode
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaxesConnected/* default */.Z, {
                            mode: mode
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OmniSearchBase, {
        className: classnames_default()(mode, {
            stacked: stacked
        }),
        "data-testid": "omni-search",
        isEbooking: isEbooking,
        disabled: disabled,
        children: content
    });
};
/* harmony default export */ var comps_OmniSearch = (OmniSearch);


/***/ }),

/***/ 17181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var src_comps_Molecules_Paxes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58252);
/* harmony import */ var src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36796);




function PaxesConnected(param) {
    var mode = param.mode, disabled = param.disabled;
    var ref = (0,src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_3__/* .useSearch */ .R)(), draftRooms = ref.draftRooms, setPaxes = ref.setPaxes;
    var handleOnChange = function(paxes) {
        setPaxes(paxes);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Molecules_Paxes__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        initialValue: draftRooms,
        onChange: handleOnChange,
        mode: mode,
        disabled: disabled
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaxesConnected);


/***/ }),

/***/ 50138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83112);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_comps_Atom_Buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9961);
/* harmony import */ var client_icons_Search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22465);
/* harmony import */ var src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36796);







var SearchButton = function(param) {
    var onClick = param.onClick, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _preventNavigation = param.preventNavigation, preventNavigation = _preventNavigation === void 0 ? false : _preventNavigation, searchUrl = param.searchUrl, _small = param.small, small = _small === void 0 ? false : _small;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var ref = (0,src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_5__/* .useSearch */ .R)(), draftLocation = ref.draftLocation, setShowSuggesterError = ref.setShowSuggesterError;
    var href = searchUrl.href, shallow = searchUrl.shallow;
    var canSearch = !!draftLocation;
    var handleClick = function(event) {
        if (!canSearch) {
            event.preventDefault();
            setShowSuggesterError(true);
            return;
        }
        onClick(event);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        shallow: shallow && preventNavigation,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Atom_Buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "a",
            size: "m",
            backgroundColor: "brand1",
            borderColor: "brand1",
            color: "grey8",
            type: "button",
            leftIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Search__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: 20
            }),
            fullWidth: fullWidth,
            onClick: handleClick,
            "data-testid": "search-button",
            children: !small && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                "data-testid": "search-button-text",
                className: "buttonText",
                children: intl.formatMessage({
                    id: "global.search"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchButton);


/***/ }),

/***/ 86998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var src_comps_Molecules_Suggester__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31405);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94449);
/* harmony import */ var src_effects_Suggester_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72319);
/* harmony import */ var src_effects_Suggester_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56736);
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59806);
/* harmony import */ var src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36796);








var mapSuggestionsToUpperCase = function(suggestion) {
    return {
        ID: suggestion.id,
        Coordinate: suggestion.coordinates,
        Country: suggestion.country,
        Slug: suggestion.slug,
        Type: suggestion.type,
        Text: suggestion.text,
        Description: suggestion.description,
        Stars: suggestion.stars,
        CitySlug: suggestion.citySlug,
        BoxShape: suggestion.boxShape
    };
};
function SuggesterConnected(param) {
    var initialValue = param.initialValue, mode = param.mode, _className = param.className, className = _className === void 0 ? "" : _className;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_4__/* .useMarket */ .A)(), language = ref.language, market = ref.market;
    var ref1 = (0,src_hooks_useSearch__WEBPACK_IMPORTED_MODULE_5__/* .useSearch */ .R)(), draftLocation = ref1.draftLocation, setLocation = ref1.setLocation, showSuggesterError = ref1.showSuggesterError;
    var suggesterSearch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(src_effects_Suggester_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getSuggesterSearch */ .QR);
    var isFetchingSuggestions = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(src_effects_Suggester_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getSuggesterIsFetching */ .g8);
    var isFirstSearch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(src_effects_Suggester_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getSuggesterIsFirstSearch */ .qC);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if ((initialValue === null || initialValue === void 0 ? void 0 : initialValue.ID) && !(draftLocation === null || draftLocation === void 0 ? void 0 : draftLocation.ID)) {
            setLocation(initialValue);
        }
        dispatch((0,src_effects_Suggester_actions__WEBPACK_IMPORTED_MODULE_7__/* .resetSuggestionsAction */ .Vg)());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var suggestions = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(src_effects_Suggester_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getSuggestions */ .vt);
    // Connect to provider to get the respective values
    var handleChangeInput = function(text) {
        if (!text) {
            dispatch((0,src_effects_Suggester_actions__WEBPACK_IMPORTED_MODULE_7__/* .resetSuggestionsAction */ .Vg)());
        }
        if (text && text.length > 1) {
            dispatch((0,src_effects_Suggester_actions__WEBPACK_IMPORTED_MODULE_7__/* .fetchSuggestionsRequestAction */ .Bu)({
                language: language,
                market: market,
                search: text,
                variant: "WEB-4624.1"
            }));
        }
    };
    var handleOnSelect = function(suggestion) {
        setLocation(suggestion);
        if (!(suggestion === null || suggestion === void 0 ? void 0 : suggestion.ID)) {
            dispatch((0,src_effects_Suggester_actions__WEBPACK_IMPORTED_MODULE_7__/* .resetSuggestionsAction */ .Vg)());
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_comps_Molecules_Suggester__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        mode: mode,
        suggestion: draftLocation,
        suggestions: suggestions.map(mapSuggestionsToUpperCase),
        onChangeInput: handleChangeInput,
        onSelect: handleOnSelect,
        className: className,
        hasError: showSuggesterError,
        suggesterSearch: suggesterSearch,
        isFetchingSuggestions: isFetchingSuggestions,
        isFirstSearch: isFirstSearch
    }, draftLocation === null || draftLocation === void 0 ? void 0 : draftLocation.ID);
}
/* harmony default export */ __webpack_exports__["Z"] = (SuggesterConnected);


/***/ }),

/***/ 33500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SearchProvider; },
/* harmony export */   "c": function() { return /* binding */ SearchContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(50853);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17620);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13888);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63761);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73053);
/* harmony import */ var src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59806);
/* harmony import */ var lib_storage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59588);
/* harmony import */ var src_types_search__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50728);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74774);
/* harmony import */ var _s4l_stayforlong_property_schemas_v3_search_legacy__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97193);
/* harmony import */ var src_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16153);
/* harmony import */ var src_constants_sources__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17224);



















var SearchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var ratingOptions = Object.values(_s4l_stayforlong_property_schemas_v3_search_legacy__WEBPACK_IMPORTED_MODULE_9__/* .RatingOptions */ .JZ);
var getValidRatings = function(values) {
    return values.filter(function(rating) {
        return ratingOptions.includes(rating);
    });
};
var sortOptionDefault = _s4l_stayforlong_property_schemas_v3_search_legacy__WEBPACK_IMPORTED_MODULE_9__/* .SortOptions.Recommended */ .oi.Recommended;
var accommodationsOptions = Object.values(src_types_search__WEBPACK_IMPORTED_MODULE_7__/* .AccommodationOptions */ .su);
var getValidAccommodations = function(values) {
    return values.filter(function(accommodation) {
        return accommodationsOptions.includes(accommodation);
    });
};
var facilitiesOptions = Object.values(src_types_search__WEBPACK_IMPORTED_MODULE_7__/* .FacilitiesOptions */ .DR);
var getValidFacilities = function(values) {
    return values.filter(function(facility) {
        return facilitiesOptions.includes(facility);
    });
};
var getValidStars = function(values) {
    return values.filter(function(star) {
        return src_types_search__WEBPACK_IMPORTED_MODULE_7__/* .starsOptions.includes */ .js.includes(star);
    });
};
var PAXES_DEFAULT_ADULTS = "2";
var PAXES_DEFAULT_CHILDREN = "";
var SearchProvider = function(param) {
    var children = param.children, value = param.value, location = param.location;
    var ref = (0,src_hooks_useMarket__WEBPACK_IMPORTED_MODULE_5__/* .useMarket */ .A)(), calendar = ref.calendar, market = ref.market;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showSuggesterError = ref1[0], setShowSuggesterError = ref1[1];
    if (value === null) {
        throw new Error("SearchContext provider can not have a null value");
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // At beggining, we set the search status to fetching to fetch data for the first time
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src_types_search__WEBPACK_IMPORTED_MODULE_7__/* .SearchStatus.Idle */ .SV.Idle), searchStatus = ref2[0], setSearchStatus = ref2[1];
    var ref3;
    var initialLocation = (ref3 = value === null || value === void 0 ? void 0 : value.location) !== null && ref3 !== void 0 ? ref3 : location;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialLocation !== null && initialLocation !== void 0 ? initialLocation : null), internalLocation = ref4[0], setInternalLocation = ref4[1];
    var initialLocationKey = (initialLocation === null || initialLocation === void 0 ? void 0 : initialLocation.Slug) ? (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getUniqueKeyFromLocation */ .D1)(initialLocation) : "";
    var locationHistory = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(new Map([
        [
            initialLocationKey,
            initialLocation
        ]
    ]));
    var locationFromUrlParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var locationFromUrl = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getLocationFromUrlParams */ .bF)(router.query);
        var locationKey = locationFromUrl ? (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getUniqueKeyFromLocation */ .D1)(locationFromUrl) : "";
        var locationFromHistory = locationHistory.current.get(locationKey);
        var ref;
        return (ref = locationFromHistory !== null && locationFromHistory !== void 0 ? locationFromHistory : locationFromUrl) !== null && ref !== void 0 ? ref : initialLocation;
    }, [
        router.query,
        locationHistory,
        initialLocation
    ]);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), page = ref5[0], setPage = ref5[1];
    var affiliate = (0,src_hooks_useBusiness__WEBPACK_IMPORTED_MODULE_10__/* .useBusiness */ .i)().affiliate;
    var today = new Date();
    var minBookingDateObject = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getMinBookingDate */ .yR)({
        year: today.getFullYear(),
        month: today.getMonth(),
        date: today.getDate(),
        hours: today.getHours(),
        minutes: today.getMinutes()
    }, {
        year: today.getUTCFullYear(),
        month: today.getUTCMonth(),
        date: today.getUTCDate(),
        hours: today.getUTCHours(),
        minutes: today.getUTCMinutes()
    });
    var year = minBookingDateObject.year, month = minBookingDateObject.month, date = minBookingDateObject.date;
    var minBookingDate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(new Date(year, month, date), calendar.inanitionDays);
    }, [
        date,
        month,
        year,
        calendar.inanitionDays
    ]);
    var _checkout;
    var ref6 = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getDateRange */ .Y_)({
        checkIn: router === null || router === void 0 ? void 0 : router.query.checkin,
        checkOut: (router === null || router === void 0 ? void 0 : router.query.checkin) ? (_checkout = router === null || router === void 0 ? void 0 : router.query.checkout) !== null && _checkout !== void 0 ? _checkout : "" : undefined,
        minBookingDate: minBookingDate,
        daysOfBooking: calendar.defaultBookingDays
    }), checkin = ref6.checkin, checkout = ref6.checkout;
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        checkIn: checkin,
        checkOut: checkout
    }), internalDates = ref7[0], setInternalDates = ref7[1];
    var _query = router.query, adultsParam = _query.adults, childrenParam = _query.children;
    var rooms = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getRoomsFromUrlParams */ .QY)({
        adults: adultsParam !== null && adultsParam !== void 0 ? adultsParam : PAXES_DEFAULT_ADULTS,
        children: childrenParam !== null && childrenParam !== void 0 ? childrenParam : PAXES_DEFAULT_CHILDREN
    });
    // check min date with utc times and update
    var setDates = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var checkIn = param.checkIn, checkOut = param.checkOut;
        var checkOutOrMinDate = checkOut || (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(checkIn, calendar.defaultBookingDays);
        setInternalDates({
            checkIn: checkIn,
            checkOut: checkOutOrMinDate
        });
    }, [
        calendar.defaultBookingDays
    ]);
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(rooms), internalRooms = ref8[0], setInternalRooms = ref8[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref = (0,lib_storage__WEBPACK_IMPORTED_MODULE_6__/* .getSearchParamsLocalStorage */ .uN)(), checkInLocal = ref.checkIn, checkOutLocal = ref.checkOut, adultsLocal = ref.adults, childrenLocal = ref.children;
        var _checkin, _checkout;
        var ref1 = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getDateRange */ .Y_)({
            checkIn: (_checkin = router === null || router === void 0 ? void 0 : router.query.checkin) !== null && _checkin !== void 0 ? _checkin : checkInLocal,
            checkOut: (router === null || router === void 0 ? void 0 : router.query.checkin) ? (_checkout = router === null || router === void 0 ? void 0 : router.query.checkout) !== null && _checkout !== void 0 ? _checkout : "" : checkOutLocal,
            minBookingDate: minBookingDate,
            daysOfBooking: calendar.defaultBookingDays
        }), checkinWithLocal = ref1.checkin, checkoutWithLocal = ref1.checkout;
        setInternalDates({
            checkIn: checkinWithLocal,
            checkOut: checkoutWithLocal
        });
        var roomsWithLocal = !adultsParam && adultsLocal ? (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getRoomsFromLocalParams */ .ig)(adultsLocal, childrenLocal) : (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getRoomsFromUrlParams */ .QY)({
            adults: adultsParam !== null && adultsParam !== void 0 ? adultsParam : PAXES_DEFAULT_ADULTS,
            children: childrenParam !== null && childrenParam !== void 0 ? childrenParam : PAXES_DEFAULT_CHILDREN
        });
        setInternalRooms(roomsWithLocal);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    var setPaxes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(newRooms) {
        setInternalRooms(newRooms);
    }, []);
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        location: internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.ID,
        checkin: internalDates.checkIn.getTime(),
        checkout: internalDates.checkOut.getTime(),
        rooms: internalRooms
    }), initialSearch = ref9[0];
    var _query1 = router.query, minPrice = _query1["min-price"];
    var _query2 = router.query, maxPrice = _query2["max-price"];
    var priceRange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!minPrice) return undefined;
        if (minPrice && !maxPrice) return {
            min: Number(minPrice)
        };
        if (Number(maxPrice) < Number(minPrice)) return {
            min: Number(minPrice)
        };
        return {
            min: Number(minPrice),
            max: Number(maxPrice)
        };
    }, [
        minPrice,
        maxPrice
    ]);
    var setPriceRange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(range) {
            var params;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, (range === null || range === void 0 ? void 0 : range.min) && {
                            "min-price": "".concat(range === null || range === void 0 ? void 0 : range.min)
                        }, (range === null || range === void 0 ? void 0 : range.max) && {
                            "max-price": "".concat(range === null || range === void 0 ? void 0 : range.max)
                        });
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, params)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(range) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var resetPriceRange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .omitQueryParams */ .sR)(router, [
                            "min-price",
                            "max-price"
                        ])
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    var _query3 = router.query, ratingsQuery = _query3.ratings;
    var ratings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!ratingsQuery) return new Set();
        if (Array.isArray(ratingsQuery)) return new Set();
        var values = ratingsQuery.split(",");
        if (values.length === 0) return new Set();
        var validOptions = getValidRatings(values);
        return new Set(validOptions);
    }, [
        ratingsQuery
    ]);
    var resetRatings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .omitQueryParams */ .sR)(router, [
                            "ratings"
                        ])
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    var setRatings = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(updatedRatings) {
            var newRatings;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(updatedRatings.size === 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            resetRatings()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        newRatings = Array.from(updatedRatings);
                        // We are converting into a comma separated string for the options
                        // otherwise next will try to make several query params with the same
                        // which makes the serialization harder.
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, {
                                ratings: newRatings.join(",")
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(updatedRatings) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router
    ]);
    var _query4 = router.query, facilitiesQuery = _query4.facilities;
    var facilities = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!facilitiesQuery) return new Set();
        if (Array.isArray(facilitiesQuery)) return new Set();
        var values = facilitiesQuery.split(",");
        if (values.length === 0) return new Set();
        var validOptions = getValidFacilities(values);
        return new Set(validOptions);
    }, [
        facilitiesQuery
    ]);
    var resetFacilities = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var newQuery;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    newQuery = lodash_omit__WEBPACK_IMPORTED_MODULE_3___default()(router.query, "facilities");
                    return [
                        4,
                        router.replace({
                            query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, newQuery)
                        }, undefined, {
                            shallow: true
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        router
    ]);
    var setFacilities = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(updatedFacilities) {
            var newFacilities;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(updatedFacilities.size === 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            resetFacilities()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        newFacilities = Array.from(updatedFacilities);
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, {
                                facilities: newFacilities.join(",")
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(updatedFacilities) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router
    ]);
    var _query5 = router.query, starsQuery = _query5.stars;
    var stars = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!starsQuery) return new Set();
        if (Array.isArray(starsQuery)) return new Set();
        var values = starsQuery.split(",");
        if (values.length === 0) return new Set();
        var validOptions = getValidStars(values);
        return new Set(validOptions);
    }, [
        starsQuery
    ]);
    var resetStars = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .omitQueryParams */ .sR)(router, [
                            "stars"
                        ])
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    var setStars = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(updatedStars) {
            var newStars;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(updatedStars.size === 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            resetStars()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        newStars = Array.from(updatedStars);
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, {
                                stars: newStars.join(",")
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(updatedStars) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router
    ]);
    var _query6 = router.query, accommodationQuery = _query6.accommodations;
    var accommodations = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!accommodationQuery) return new Set();
        if (Array.isArray(accommodationQuery)) return new Set();
        var values = accommodationQuery.split(",");
        if (values.length === 0) return new Set();
        var validOptions = getValidAccommodations(values);
        return new Set(validOptions);
    }, [
        accommodationQuery
    ]);
    var resetAccommodations = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .omitQueryParams */ .sR)(router, [
                            "accommodations"
                        ])
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    var setAccommodations = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(updatedAccommodations) {
            var newAccommodations;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(updatedAccommodations.size === 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            resetAccommodations()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        newAccommodations = Array.from(updatedAccommodations);
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, {
                                accommodations: newAccommodations.join(",")
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(updatedAccommodations) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router
    ]);
    var filtersParams = [
        "min-price",
        "max-price",
        "stars",
        "ratings",
        "family",
        "accommodations",
        "facilities", 
    ];
    var resetFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .omitQueryParams */ .sR)(router, filtersParams)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        router
    ]);
    var setFilters = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(updatedFilters) {
            var range, familyFriendly, rest, params, currentParams;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        range = updatedFilters.range, familyFriendly = updatedFilters.familyFriendly, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(updatedFilters, [
                            "range",
                            "familyFriendly"
                        ]);
                        params = {};
                        if (range === null || range === void 0 ? void 0 : range.max) {
                            params["max-price"] = "".concat(range.max);
                        }
                        if (range === null || range === void 0 ? void 0 : range.min) {
                            params["min-price"] = "".concat(range.min);
                        }
                        if (familyFriendly) {
                            params.family = "true";
                        }
                        Object.entries(rest).forEach(function(param) {
                            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(param, 2), filterName = _param[0], filterValue = _param[1];
                            if (filterValue.size > 0) {
                                params[filterName] = Array.from(filterValue).join(",");
                            }
                        });
                        currentParams = lodash_omit__WEBPACK_IMPORTED_MODULE_3___default()(router.query, filtersParams);
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, params, currentParams)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(updatedFilters) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router
    ]);
    var getValidSortBy = function(sortValue) {
        var foundSortOption = Object.values(_s4l_stayforlong_property_schemas_v3_search_legacy__WEBPACK_IMPORTED_MODULE_9__/* .SortOptions */ .oi).find(function(sortByOption) {
            return sortByOption === sortValue;
        });
        return foundSortOption;
    };
    var highlightedProperty = router.query.highlightedProperty;
    var _query7 = router.query, sortByQuery = _query7.sort;
    var sortBy = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!sortByQuery) {
            return _s4l_stayforlong_property_schemas_v3_search_legacy__WEBPACK_IMPORTED_MODULE_9__/* .SortOptions.Recommended */ .oi.Recommended;
        }
        var isValidSort = getValidSortBy(sortByQuery);
        return isValidSort !== null && isValidSort !== void 0 ? isValidSort : sortOptionDefault;
    }, [
        sortByQuery
    ]);
    var setSortBy = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(newSortBy) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, {
                                sort: newSortBy
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newSortBy) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var _query8 = router.query, familyQuery = _query8.family;
    var familyFriendly = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return familyQuery === "true";
    }, [
        familyQuery
    ]);
    var setFamilyFriendly = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(newFamilyFriendly) {
            var params, currentParams;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, newFamilyFriendly && {
                            family: "true"
                        });
                        currentParams = lodash_omit__WEBPACK_IMPORTED_MODULE_3___default()(router.query, [
                            "family"
                        ]);
                        return [
                            4,
                            (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .replaceQueryParams */ .ko)(router, params, currentParams)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(newFamilyFriendly) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router
    ]);
    var setLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(newLocation) {
        setInternalLocation(newLocation);
        setShowSuggesterError(false);
        if (newLocation === null || newLocation === void 0 ? void 0 : newLocation.Slug) {
            var key = (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getUniqueKeyFromLocation */ .D1)(newLocation);
            locationHistory.current.set(key, newLocation);
        }
    }, []);
    var nextPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            setPage(page + 1);
            return [
                2
            ];
        });
    }), [
        page,
        setPage
    ]);
    var resetPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            setPage(1);
            return [
                2
            ];
        });
    }), [
        setPage
    ]);
    var changeState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function(action) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                setSearchStatus((0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .updateSearchStatus */ .Mv)(searchStatus, action));
                return [
                    2
                ];
            });
        });
        return function(action) {
            return _ref.apply(this, arguments);
        };
    }(), [
        searchStatus
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var handleRouterChange = function() {
            changeState(src_types_search__WEBPACK_IMPORTED_MODULE_7__/* .SearchActions.Fetch */ .PC.Fetch);
        };
        (ref = router.events) === null || ref === void 0 ? void 0 : ref.on("routeChangeComplete", handleRouterChange);
        return function() {
            var ref;
            (ref = router.events) === null || ref === void 0 ? void 0 : ref.off("routeChangeComplete", handleRouterChange);
        };
    }, [
        router,
        changeState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setInternalLocation(locationFromUrlParams);
    }, [
        locationFromUrlParams
    ]);
    var searchAffiliate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var actualSearch = {
            location: internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.ID,
            checkin: internalDates.checkIn.getTime(),
            checkout: internalDates.checkOut.getTime(),
            rooms: internalRooms
        };
        var source = router.query.source;
        if (!(0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .hasChangeSearch */ .be)(initialSearch, actualSearch) && affiliate) {
            var sourceValue = source !== null && source !== void 0 ? source : src_constants_sources__WEBPACK_IMPORTED_MODULE_11__/* .DEFAULT_SOURCE */ .WJ;
            return {
                affiliate: affiliate,
                source: sourceValue
            };
        }
        return {
            affiliate: affiliate,
            source: src_constants_sources__WEBPACK_IMPORTED_MODULE_11__/* .DEFAULT_SOURCE */ .WJ
        };
    }, [
        router,
        initialSearch,
        internalLocation,
        internalDates,
        internalRooms,
        affiliate
    ]);
    var queryParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            checkin: (0,date_fns__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(internalDates.checkIn, "yyyy-MM-dd"),
            checkout: (0,date_fns__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(internalDates.checkOut, "yyyy-MM-dd"),
            children: internalRooms.map(function(room) {
                return room.children.join(",");
            }).join("!"),
            adults: internalRooms.map(function(room) {
                return room.adults;
            }).join(",")
        };
    }, [
        internalDates,
        internalRooms
    ]);
    var geoQueryParams = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return internalLocation && (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .isGeo */ .He)(internalLocation.Type) ? {
            type: src_types_search__WEBPACK_IMPORTED_MODULE_7__/* .LocationTypes.Geo */ .aD.Geo,
            boxshape: (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .boxShapeToArray */ .f_)(internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.BoxShape)
        } : {};
    }, [
        internalLocation
    ]);
    var searchUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!internalLocation) {
            // In this case we not want to navigate no any place, only show error message
            return {
                href: {
                    pathname: router.asPath,
                    query: router.query
                },
                shallow: false
            };
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .isProperty */ .IC)(internalLocation.Type)) {
            return {
                href: {
                    pathname: "/hotel/[country]/[slug]",
                    query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, queryParams), {
                        country: internalLocation.Country,
                        slug: "".concat(internalLocation.Slug, "_").concat(internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.CitySlug)
                    })
                },
                shallow: false
            };
        }
        var filters = lodash_pick__WEBPACK_IMPORTED_MODULE_4___default()(router.query, [
            "min-price",
            "max-price",
            "stars",
            "ratings",
            "accommodations",
            "facilities",
            "sort",
            "family", 
        ]);
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .isGeo */ .He)(internalLocation.Type)) {
            return {
                href: {
                    pathname: "/search",
                    query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, queryParams, filters, geoQueryParams)
                },
                shallow: true
            };
        }
        return {
            href: {
                pathname: "/search",
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                    country: internalLocation.Country,
                    type: internalLocation.Type,
                    slug: internalLocation.Slug
                }, queryParams, (internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.ID) === (location === null || location === void 0 ? void 0 : location.ID) && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, filters))
            },
            shallow: true
        };
    }, [
        router,
        internalLocation,
        queryParams,
        geoQueryParams,
        location
    ]);
    var oldSearchUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!internalLocation) {
            // In this case we not want to navigate no any place, only show error message
            return {
                href: {
                    pathname: router.asPath,
                    query: router.query
                },
                shallow: false
            };
        }
        if ((0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .isProperty */ .IC)(internalLocation.Type)) {
            return {
                href: {
                    pathname: "/hotel/[country]/[slug]",
                    query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, queryParams), {
                        country: internalLocation.Country,
                        slug: "".concat(internalLocation.Slug, "_").concat(internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.CitySlug)
                    })
                },
                shallow: false
            };
        }
        var filters = lodash_pick__WEBPACK_IMPORTED_MODULE_4___default()(router.query, [
            "checkin",
            "checkout",
            "children",
            "adults"
        ]);
        return {
            href: {
                pathname: "/[country]/[type]/[slug]",
                query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                    country: internalLocation.Country,
                    type: internalLocation.Type,
                    slug: internalLocation.Slug
                }, queryParams, (internalLocation === null || internalLocation === void 0 ? void 0 : internalLocation.ID) === (location === null || location === void 0 ? void 0 : location.ID) && (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, filters))
            },
            shallow: true
        };
    }, [
        router,
        internalLocation,
        queryParams,
        location
    ]);
    var searchValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            checkin: checkin,
            draftCheckin: internalDates.checkIn,
            checkout: checkout,
            draftCheckout: internalDates.checkOut,
            setDates: setDates,
            rooms: rooms,
            draftRooms: internalRooms,
            setPaxes: setPaxes,
            market: market,
            minBookingDate: minBookingDate,
            daysOfBooking: calendar.daysOfBooking,
            priceRange: priceRange,
            setPriceRange: setPriceRange,
            resetPriceRange: resetPriceRange,
            familyFriendly: familyFriendly,
            setFamilyFriendly: setFamilyFriendly,
            facilities: facilities,
            setFacilities: setFacilities,
            resetFacilities: resetFacilities,
            accommodations: accommodations,
            setAccommodations: setAccommodations,
            resetAccommodations: resetAccommodations,
            stars: stars,
            setStars: setStars,
            resetStars: resetStars,
            sortBy: sortBy,
            setSortBy: setSortBy,
            ratings: ratings,
            setRatings: setRatings,
            resetRatings: resetRatings,
            location: locationFromUrlParams,
            draftLocation: internalLocation,
            setLocation: setLocation,
            searchStatus: searchStatus,
            setSearchStatus: setSearchStatus,
            changeState: changeState,
            page: page,
            setPage: setPage,
            nextPage: nextPage,
            resetPage: resetPage,
            highlightedProperty: parseInt(highlightedProperty, 10),
            setFilters: setFilters,
            resetFilters: resetFilters,
            searchUrl: searchUrl,
            oldSearchUrl: oldSearchUrl,
            searchAffiliate: searchAffiliate,
            showSuggesterError: showSuggesterError,
            setShowSuggesterError: setShowSuggesterError
        };
    }, [
        checkin,
        checkout,
        internalDates,
        setDates,
        rooms,
        internalRooms,
        setPaxes,
        market,
        minBookingDate,
        calendar.daysOfBooking,
        priceRange,
        setPriceRange,
        resetPriceRange,
        familyFriendly,
        setFamilyFriendly,
        facilities,
        setFacilities,
        resetFacilities,
        accommodations,
        setAccommodations,
        resetAccommodations,
        stars,
        setStars,
        resetStars,
        sortBy,
        setSortBy,
        ratings,
        setRatings,
        resetRatings,
        locationFromUrlParams,
        internalLocation,
        setLocation,
        searchStatus,
        setSearchStatus,
        changeState,
        page,
        setPage,
        nextPage,
        resetPage,
        highlightedProperty,
        setFilters,
        resetFilters,
        searchUrl,
        oldSearchUrl,
        searchAffiliate,
        showSuggesterError,
        setShowSuggesterError, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchContext.Provider, {
        value: searchValue,
        children: children
    });
};



/***/ }),

/***/ 36796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useSearch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var src_context_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33500);


var useSearch = function() {
    var search = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_context_search__WEBPACK_IMPORTED_MODULE_1__/* .SearchContext */ .c);
    if (!search) {
        throw new Error("Missing SearchContext provider");
    }
    return search;
};


/***/ })

}]);